import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import MessengerMessage from './MessengerMessage';
import { setSelectedFeedback, ajaxFeedback, getRequestedVia, getStarsJSX, getChatStatus } from '../../redux/FeedbackRedux';


class MessengerMessages extends React.Component {

	render() {
		var chats = this.props.feedback.chats;
		const chat_messages = chats.map((value, index) =>
			<MessengerMessage key={index} chat={value} id={value.id} red_alerts_list={this.props.red_alerts_list} />
		);
		return (
			<div className="chat_widget_body">
				{chat_messages}
			</div>
		);
	}
}

function mapStateToProps(state) {
	return { feedback: state.feedback_detail, red_alerts: state.red_alerts ?? null, red_alerts_list: state.red_alerts_list ?? null }
}

export default connect(mapStateToProps)(MessengerMessages)
